import { apiClient } from '../utils/apiClient';

export const NotificationService = {
  async getNotifications(accessToken) {
    const token = accessToken || localStorage.getItem('llap_access_token') || localStorage.getItem('llap_auth_token');
    if (!token) {
      return { success: true, notifications: [] };
    }

    try {
      const response = await apiClient.get('/.netlify/functions/notifications', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response && response.success) {
        return response;
      }
      return { success: true, notifications: [] };
    } catch (error) {
      console.warn('NotificationService get error (falling back to local storage):', error.message);
      const localNotifs = JSON.parse(localStorage.getItem('llap_notifications') || '[]');
      return { success: true, notifications: localNotifs };
    }
  }
};

export default NotificationService;